import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";

@Injectable({
    providedIn: "root",
})
export class DynamicFormService {
    constructor(private http: HttpClient) {}

    getAllDynamicForms(): Observable<any> {
        return this.http.get<any>(`${environment.api}/api/customer/forms`);
    }

    getFormBySlug(slug: string): Observable<any> {
        return this.http.get<any>(
            `${environment.api}/api/customer/forms/${slug}`
        );
    }

    submitResponse(form_id: number, data: any): Observable<any> {
        return this.http.post<any>(
            `${environment.api}/api/customer/forms/${form_id}/responses`, data
        );
    }
}
